import nexus from '@db2b/nexus-js'

const state = {
  all: []
}

const getters = {
  all: state => state.all
}

const actions = {
  load ({commit, state}) {
    return nexus.get('callcenter', '/reminder_categories')
      .then(response => {
        state.all = response.data.data
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/callcenter/reminder_categories.js